import { createTheme } from "@mui/material";
import { fontStyles } from "./fontStyles";
import c from "lib/style/colorVar.scss";

/**
 * @typedef {"auth-button" | "normal-button" | "outline-normal-button"} buttonVariant
 */

export const theme = createTheme({
  typography: {
    fontFamily: "Noto Sans, Roboto, sans-serif",
    ...fontStyles,
  },
  components: {
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          color: c.brand1, // Ripple color (red with transparency)
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        fontFamily: "Noto Sans, Roboto, sans-serif",
        color: c["black"],
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          variants: [
            {
              props: { variant: "auth-button" },
              style: () => ({
                backgroundColor: c["yellow"],
                color: c["yellowWordings"],
                height: "45px",
                width: "100%",
                borderRadius: "32px",
                border: "none",
                marginTop: "16px",
                marginBottom: "16px",
                cursor: "pointer",
                ":disabled": {
                  backgroundColor: c["yellowHover"],
                },
                ":hover": {
                  backgroundColor: "#f1bf0c",
                },
              }),
            },
            {
              props: { variant: "normal-button" },
              style: () => ({
                backgroundColor: c["brandDark12"],
                color: "white",
                borderRadius: "4px",
                // border: "none",
                border: "solid 1px",
                borderColor: c["brandDark12"],
                cursor: "pointer",
                ":disabled": {
                  backgroundColor: c["brandLight64"],
                  borderColor: c["brandLight64"],
                  color: "white",
                },
                ":hover": {
                  backgroundColor: c["brand1"],
                  borderColor: c["brand1"],
                },
              }),
            },
            {
              props: { variant: "outline-normal-button" },
              style: () => ({
                backgroundColor: "transparent",
                color: c["brandDark12"],
                borderRadius: "4px",
                border: "solid 1px",
                borderColor: c["brandDark12"],
                cursor: "pointer",
                ":disabled": {
                  color: c["blackLightCCC"],
                  borderColor: c["blackLightCCC"],
                  backgroundColor: "transparent",
                },
                ":hover": {
                  backgroundColor: c["brandLight85"],
                },
              }),
            },
            {
              props: { variant: "adornment-button" },
              style: () => ({
                minHeight: 32,
                maxHeight: 32,
                minWidth: 32,
                maxWidth: 32,
                borderRadius: 16,
                marginRight: "-12px", // Align with other adornments
              })
            },
            {
              props: { variant: "text-only" },
              style: () => ({
                backgroundColor: "transparent",
                color: c["brandDark12"],
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                ":disabled": {
                  color: c["blackLightCCC"],
                  backgroundColor: "transparent",
                },
                ":hover": {
                  backgroundColor: "transparent",
                },
              }),
            }
          ],
        },
      },
    },
  },
});
